import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Kudo = props => {
  return <Dropdown.Static kubunKey='kudo' {...props} />
}
